import React, {useState} from 'react';
import { Navigate } from "react-router-dom";
import axios from 'axios';
import LoginBg from '../images/logo-large.png';
import axiosInstances from '../components/axiosInstance';

const Login =()=>{

    const [email, setEmail] = useState(''); 
    const [password, setPassword] = useState(''); 
    //const [sub, setSub] = useState(false)
    const [redirect, setRedirect] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const[loading, setLoading] = useState(false);
    const [hasError,setHasError] = useState(false);
    axios.defaults.withCredentials = true;

    const submit = async (e) =>{
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");
        setHasError(false);
        try {
            
            //  console.log(data.headers)
            const {data} = await axiosInstances.write.post('login',{
                email, 
                password,
            });
            const responseCode = data.response_code
            if(responseCode === "60041"){
                setErrorMessage(data.message);
                setHasError(true);
            }
            if(responseCode === "60042"){
                setErrorMessage(data.message);
                setHasError(true);
            }
            
            if(responseCode === "0"){
                //setSub(true);
                // console.log("Is a subscriber sub:" + sub)
                setHasError(false);
                setRedirect(true);
            }
        } catch (error) {
            console.log(error.code);
            if (error.message === "Network Error") {
                setErrorMessage("Failed to connect to the server. Please try again later.");
            } else if(error.code==="ERR_BAD_REQUEST"){
                setErrorMessage("Wrong Email or password. Try again");
            } else {
                setErrorMessage("An error occurred. Please try again later.");
            } 
            setHasError(true);
            
        } 
        finally{
            setLoading(false);
           // setHasError(false);
        }
        
        
        
    }
    const passableParams = {
        email
    }
 
    if(redirect){
        return <Navigate to={'/'}  replace={true}  state={ passableParams } />;
    }
   
    return (
        <>
        <form onSubmit={submit}>
        <div className="flex items-center min-h-screen p-6 bg-gray-50 dark:bg-gray-900">
      <div
        className="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl dark:bg-gray-800"
      >
        <div className="flex flex-col overflow-y-auto md:flex-row">
        <div className="h-32 md:h-auto md:w-1/2 flex items-center justify-center">
            <div className="max-w-[40%]">
                <img
                aria-hidden="true"
                className="dark:hidden"
                src={LoginBg}
                alt="FSM"
                />
            </div>
        </div>
          
            <div className="flex items-center justify-center p-6 sm:p-12 md:w-1/2">
                <div className="w-full">
                <h1
                    className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200"
                >
                   Login
                </h1>
                
                <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">Email</span>
                    <input
                    type="email"
                    
                    className="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                    placeholder="email" onChange={e => setEmail(e.target.value) }
                    />
                </label>

                <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">Password</span>
                    <input
                    type="password"
                   
                    className="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                    placeholder="XXXX" onChange={e => setPassword(e.target.value) }
                    />
                </label>


                {/* <!-- You should use a button here, as the anchor is only used for the example  --> */}
                <button
                    className={`block w-full px-4 py-2 mt-4 text-sm font-medium leading-5 text-center text-white transition-colors duration-150 bg-teal-700 border border-transparent rounded-lg active:bg-teal-700 hover:bg-teal-700 focus:outline-none focus:shadow-outline-teal`}
                    onClick={submit}
                    disabled={loading}
                >
                     {loading ? 'Loading...' : 'Login'}
                </button>
                {hasError&&
                (
                <div className="bg-red-500 text-white leading-5 text-center mt-4 text-sm  px-4 py-2">
                    {errorMessage}
                </div>
                )
                }
                
                
                <p className="mt-4">
                    
                </p>
                
                </div>
            </div>
          
           
        </div>
      </div>
    </div>
        </form>
         
        </>
    );
}

export default Login;